import {withRouteRequiringPermission} from '../../Molecules/PermissionBoundary'

import {DocumentsPage as Documents} from './Documents'

export const ROUTE = '/documents'

export default withRouteRequiringPermission({
  path: ROUTE,
  label: 'Documents',
  labelKey: 'sharePointDocuments.navigationLabel',
  permissions: ['VIEW_INVOICES', 'VIEW_CUSTOMERS', 'VIEW_MATERIALCERTIFICATES'],
  order: 99,
  featureToggleName: 'EnableSharepointDocuments'
})(Documents)
